module.exports = __webpack_public_path__ + "f3937a65b915a07fbf4d78bfa999fd38.svg";